"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _table = _interopRequireDefault(require("britive-design-system/core/components/table"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _constants = require("../data-table/constants");

var _commonConstants = require("../../utils/common-constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n";
  var fileName = "compone_DataTableInfiniteScroll";
  var element = document.querySelector("style[data-sass-component='compone_DataTableInfiniteScroll']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var RESULTS_PER_PAGE = 25;

var DataTableInfiniteScroll = function DataTableInfiniteScroll(_ref) {
  var _tableData$info3;

  var dataUrl = _ref.dataUrl,
      tableData = _ref.tableData,
      columns = _ref.columns,
      dispatchAction = _ref.dispatchAction,
      _ref$withPaginationUr = _ref.withPaginationUrl,
      withPaginationUrl = _ref$withPaginationUr === void 0 ? true : _ref$withPaginationUr,
      infiniteScrollLoadingText = _ref.infiniteScrollLoadingText,
      totalCount = _ref.totalCount,
      currentPage = _ref.currentPage,
      status = _ref.status;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      sortQuery = _useState2[0],
      setSortQuery = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      searchQuery = _useState4[0],
      setSearchQuery = _useState4[1];

  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (withPaginationUrl) {
      dispatch(dispatchAction(dataUrl));
    } else {
      dispatch(dispatchAction(dataUrl, {
        page: 0,
        size: RESULTS_PER_PAGE,
        searchText: searchQuery
      }));
    }
  }, [sortQuery, searchQuery]);

  var handleScrollWithPaginationUrl = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _tableData$info;

      var _tableData$info2;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (tableData !== null && tableData !== void 0 && (_tableData$info = tableData.info) !== null && _tableData$info !== void 0 && _tableData$info.next) {
                dispatch(dispatchAction(tableData === null || tableData === void 0 ? void 0 : (_tableData$info2 = tableData.info) === null || _tableData$info2 === void 0 ? void 0 : _tableData$info2.next));
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleScrollWithPaginationUrl() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleScrollWithoutPaginationUrl = function handleScrollWithoutPaginationUrl() {
    if (totalCount && totalCount > tableData.length) {
      dispatch(dispatchAction(dataUrl, {
        page: currentPage + 1,
        size: RESULTS_PER_PAGE,
        searchText: searchQuery
      }));
    }
  };

  var handleSort = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(sortOrdr, sortBy) {
      var queryParam;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              queryParam = "".concat(sortBy);

              if (sortOrdr === 'ascending') {
                queryParam += ',asc';
              } else if (sortOrdr === 'descending') {
                queryParam += ',desc';
              } else if (sortOrdr === 'unsorted') {
                queryParam = undefined;
              }

              setSortQuery(queryParam);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSort(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onSearch = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(value) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // This is done to prevent empty string to pass as a search filter.
              setSearchQuery(value || undefined);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onSearch(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement("div", null, status === _commonConstants.RESOURCE_STATUS.LOADING && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: _constants.spinnerSize,
    message: '',
    overlay: true
  }), /*#__PURE__*/_react.default.createElement(_table.default, {
    columns: columns,
    rows: tableData || [],
    nextPageLink: withPaginationUrl ? tableData === null || tableData === void 0 ? void 0 : (_tableData$info3 = tableData.info) === null || _tableData$info3 === void 0 ? void 0 : _tableData$info3.next : true,
    hasInfiniteScroll: true,
    onScrollEnd: withPaginationUrl ? handleScrollWithPaginationUrl : handleScrollWithoutPaginationUrl,
    sortHandler: handleSort,
    infiniteScrollLoadingText: infiniteScrollLoadingText,
    scrollThreshold: 0.7,
    searchBar: {
      onSearch: onSearch,
      placeholder: 'Search'
    }
  }));
};

DataTableInfiniteScroll.propTypes = {
  dataUrl: _propTypes.default.string.isRequired,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    field: _propTypes.default.string,
    headerName: _propTypes.default.string.isRequired,
    sortable: _propTypes.default.bool,
    width: _propTypes.default.string,
    horizontalAlignment: _propTypes.default.string
  })).isRequired,
  tableData: _propTypes.default.array,
  totalCount: _propTypes.default.number,
  currentPage: _propTypes.default.number,
  dispatchAction: _propTypes.default.func.isRequired,
  stateDataPath: _propTypes.default.string,
  withPaginationUrl: _propTypes.default.bool,
  infiniteScrollLoadingText: _propTypes.default.string,
  status: _propTypes.default.string
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var apiResponse = (0, _lodash.get)(state, ownProps.stateDataPath, {});
  return {
    tableData: (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) || [],
    totalCount: apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.count,
    currentPage: apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.page,
    status: apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.status
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(DataTableInfiniteScroll);

exports.default = _default;